export default "__VITE_ASSET__b16804d6__"